export const USER_PROFILE = "user/profile";
export const UPLOAD_FILE = "file/upload";
export const UPDATE_TOUR_COMPLETION = "user/updateTourCompletion";
export const FETCH_TOUR_GUIDES = "user/fetchTourGuides";
